import { render, staticRenderFns } from "./BsiContinuousFilingMessagesDetails.vue?vue&type=template&id=50dc7566&scoped=true&"
import script from "./BsiContinuousFilingMessagesDetails.vue?vue&type=script&lang=js&"
export * from "./BsiContinuousFilingMessagesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dc7566",
  null
  
)

export default component.exports